export enum NAVIGATION {
  MAIN_NAV = 'mainNav',
  DESKTOP_ACTIONS = 'desktopActions',
  TABLET_ACTIONS = 'tabletActions',
  MOBILE_ACTIONS = 'mobileActions',
  LINK = 'navLink',
}

export const PARENT_FIELD = 'parent'; // The field name used for parent documents, e.g. a parent page
export const LOCALISE_LANGUAGE_FIELD_NAME = 'language';
